import { Component, OnInit } from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { ApiservicesService } from '../../../apiservices.service';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-agihan',
  templateUrl: './agihan-hubungan.component.html',
  styleUrls: ['./agihan-hubungan.component.css']
})
export class AgihanHubunganComponent implements OnInit {
  todo = ['Get to work', 'Pick up groceries', 'Go home', 'Fall asleep'];
  done = ['Get up', 'Brush teeth', 'Take a shower', 'Check e-mail', 'Walk dog'];

  //Constant
  AgentIDConst: any = "";
  RoleConst: any = "";
  SupervisorConst: any = "";

  //UI List Variables
  AgentListView: any = new Array;
  SupervisorListView: any = new Array;
  StaffWithRelationshipWithAgentListView: any = new Array;
  StaffWithoutRelationshipWithAgentListView: any = new Array;
  StaffWithRelationshipWithSupervisorListView: any = new Array;
  StaffWithoutRelationshipWithSupervisorListView: any = new Array;

  //UI Input Variables
  AgentInput: any = "";
  RoleInput: any = "";
  SupervisorInput: any = "";
  StaffWithRelationshipWithAgentListInput: any = new Array;
  StaffWithoutRelationshipWithAgentListInput: any = new Array;
  StaffWithRelationshipWithSupervisorListInput: any = new Array;
  StaffWithoutRelationshipWithSupervisorListInput: any = new Array;

  //UI Status Variables
  LoaderStatus: boolean = false;
  AgentStatus: boolean = false;
  StaffStatus: boolean = false;

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //Session Variables
  SessionFirmID: any = "";
  SessionStaffID: any = "";

  constructor(private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.top.updateTotal();
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.GetAgent(this.SessionFirmID);
    this.GetSupervisor(this.SessionFirmID);
  }
  dropWith(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      this.StaffWithRelationshipWithAgentListInput = [];
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.StaffWithRelationshipWithAgentListInput = event.container.data;
    }
  }
  dropWithout(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      this.StaffWithoutRelationshipWithAgentListInput = [];
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.StaffWithoutRelationshipWithAgentListInput = event.container.data;
    }
  }

  dropSupervisorWith(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      this.StaffWithRelationshipWithSupervisorListInput = [];
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.StaffWithRelationshipWithSupervisorListInput = event.container.data;
    }
  }
  dropSupervisorWithout(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      this.StaffWithoutRelationshipWithSupervisorListInput = [];
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.StaffWithoutRelationshipWithSupervisorListInput = event.container.data;
    }
  }

  async GetAgent(FirmID: any) {
    let Params = {
      FirmID: FirmID,
      Role: "0204"
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentListView = result;
  }
  HantarAgent(AgentID: any, Role: any) {
    this.LoaderStatus = true;
    if (AgentID === "" || Role === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.AgentIDConst = AgentID;
      this.RoleConst = Role;
      this.GetStaffUnderAgent(AgentID, this.SessionFirmID, Role);
    }
  }
  async GetStaffUnderAgent(TaxAgentID: any, FirmID: any, Role: any) {
    this.StaffWithRelationshipWithAgentListView = [];
    this.StaffWithoutRelationshipWithAgentListView = [];
    let Params = {
      "FirmID": FirmID,
      "TaxAgentID": TaxAgentID,
      "Role": Role
    }
    const result = await this.apiServices.GetNoRelationshipAgentStaff(Params);
    this.StaffWithRelationshipWithAgentListView = result[0].relationship;
    this.StaffWithoutRelationshipWithAgentListView = result[0].noRelationship;
    this.StaffWithRelationshipWithAgentListInput = this.StaffWithRelationshipWithAgentListView;
    this.StaffWithoutRelationshipWithAgentListInput = this.StaffWithoutRelationshipWithAgentListView;

    this.LoaderStatus = false;
    this.AgentStatus = true;
  }
  async SubmitAgentAdd(AgentID:any, WithData:any, WithoutData:any) {
    let Params = {
      FirmID: this.SessionFirmID,
      TaxAgentID: AgentID,
      ActionStaffID: this.SessionStaffID,
      WithoutRelationship: WithoutData,
      WithRelationship: WithData
    }
    const result = await this.apiServices.InsertStaffAgentRelationShip(Params);
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.GetStaffUnderAgent(AgentID, this.SessionFirmID, this.RoleConst);
      this.AlertType = "success";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    }
  }
  async GetSupervisor(FirmID:any) {
    let Params = {
      FirmID: FirmID,
      Role: "0202"
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.SupervisorListView = result;
  }
  HantarSupervisor(StaffID: any) {
    this.LoaderStatus = true;
    if (StaffID === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.SupervisorConst = StaffID;
      this.GetStaffUnderSupervisor(StaffID, this.SessionFirmID);
    }
  }
  async GetStaffUnderSupervisor(StaffID: any, FirmID: any) {
    this.StaffWithRelationshipWithSupervisorListView = [];
    this.StaffWithoutRelationshipWithSupervisorListView = [];
    let Params = {
      "FirmID": FirmID,
      "StaffID": StaffID,
      "Role": "0203"
    }
    const result = await this.apiServices.GetNoRelationshipStaff(Params);
    this.StaffWithRelationshipWithSupervisorListView = result[0].relationship;
    this.StaffWithoutRelationshipWithSupervisorListView = result[0].noRelationship;
    this.StaffWithRelationshipWithSupervisorListInput = this.StaffWithRelationshipWithSupervisorListView;
    this.StaffWithoutRelationshipWithSupervisorListInput = this.StaffWithoutRelationshipWithSupervisorListView;
    this.StaffStatus = true;
    this.LoaderStatus = false;
  }
  async SubmitSupervisorAdd(SupervisorID: any, WithData: any, WithoutData: any) {
    let Params = {
      FirmID: this.SessionFirmID,
      StaffID: SupervisorID,
      ActionStaffID: this.SessionStaffID,
      WithoutRelationship: WithoutData,
      WithRelationship: WithData
    }
    const result = await this.apiServices.InsertStaffRelationShip(Params);
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.GetStaffUnderSupervisor(SupervisorID, this.SessionFirmID);
      this.AlertType = "success";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      this.LoaderStatus = false;
    }
  }
  ResetValue() {
    this.GetAgent(this.SessionFirmID);
    this.GetSupervisor(this.SessionFirmID);
    this.AgentIDConst = "";
    this.RoleConst = "";
    this.SupervisorConst = "";

    //UI List Variables
    this.StaffWithRelationshipWithAgentListView = new Array;
    this.StaffWithoutRelationshipWithAgentListView = new Array;
    this.StaffWithRelationshipWithSupervisorListView = new Array;
    this.StaffWithoutRelationshipWithSupervisorListView = new Array;

    //UI Input Variables
    this.AgentInput = "";
    this.RoleInput = "";
    this.SupervisorInput = "";
    this.StaffWithRelationshipWithAgentListInput = new Array;
    this.StaffWithoutRelationshipWithAgentListInput = new Array;
    this.StaffWithRelationshipWithSupervisorListInput = new Array;
    this.StaffWithoutRelationshipWithSupervisorListInput = new Array;

    //UI Status Variables
    this.LoaderStatus = false;
    this.AgentStatus = false;
    this.StaffStatus = false;
  }
}
